import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Paper, TextField, Box } from '@mui/material';
import logo from '../images/logo-cnm-blue.png';
import { useSnackbar } from 'notistack';

import api from '../service/Api';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    async function handleLogin(e) {
        e.preventDefault();

        try {
            const response = await api.post('api/login', { email, password });
            enqueueSnackbar('Login efetuado', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } } );
            localStorage.setItem('token', response.data.data.token);
            navigate('/home');
        } catch (err) {
            if (err.response && err.response.status === 403) {
                enqueueSnackbar('Usuário não aprovado. Aguarde pela aprovação!', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            } else {
                enqueueSnackbar(err.response.data.message, {variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' }})
            }
            console.error('Erro durante o login:', err);
        }
    }

    return (
        <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            <Grid item xs={10} sm={6} md={4}>
                <Paper elevation={6} style={{ padding: 20, borderRadius: 15 }}>
                    <Box display="flex" justifyContent="center" marginBottom={2}>
                        <img src={logo} alt='Logo CNM' style={{ maxWidth: '50%', height: 'auto' }} />
                    </Box>
                    <form onSubmit={handleLogin}>
                        <Box display="flex" flexDirection="column">
                            <TextField
                                variant='outlined'
                                type='email'
                                label="E-mail"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                size='small'
                                margin="normal"
                                required
                            />
                            <TextField
                                variant='outlined'
                                label="Senha"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                size='small'
                                margin="normal"
                                required
                            />
                            <Grid container justifyContent="space-between" alignItems="center" marginTop={2}>
                                <Button variant='contained' type="submit" sx={{ borderRadius: '8px' }}>Entrar</Button>
                                <Button variant='text' href="/register" sx={{ borderRadius: '8px' }}>
                                    Novo cadastro
                                </Button>
                            </Grid>
                        </Box>
                    </form>
                </Paper>
            </Grid>
        </Grid>
    );
}
